import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import { Vector as VectorLayer } from 'ol/layer'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import Polygon from 'ol/geom/Polygon'
import {
  Circle as CircleStyle,
  Fill,
  Icon,
  Stroke,
  Style,
  Text
} from 'ol/style'
import * as turf from '@turf/turf'
import ClusterSource from 'ol/source/Cluster'
import { chunk } from 'lodash'
import axios from 'axios'

/* global axios */
const kulturarvByggnader = ({ kommun, type, byggnadsInvIds }) => {
  const onByggnadsInventering = _.includes(window.location.pathname, 'byggnadsinventering')
  const typeName = type || `view_kulturarv_omraden_${kommun.toLowerCase()}`

  const source = new VectorSource({
    format: new GeoJSON(),
    projection: 'EPSG:3857',
    loader: function (extent, resolution, projection) {
      var proj = projection.getCode()

      if (byggnadsInvIds) {
        const parts = typeName.split('_')
        const municipality = parts.slice(2).join('_')
        let filteredByggnadsInvIds = _.isEmpty(byggnadsInvIds) ? [["''"]] : byggnadsInvIds.filter(id => id.includes(municipality))
        filteredByggnadsInvIds = chunk(filteredByggnadsInvIds, 30)

        const promises = _.map(filteredByggnadsInvIds, (ids, index) => {
          return axios.post(`${process.env.MIX_ASSET_URL}/api/ltv/wfs`, {
            typeName,
            srsname: proj,
            outputFormat: 'application/json',
            cql_filter: _.isEmpty(ids) ? null : `byggnadsid IN (${ids.join(',')})`
          // bbox: extent.join(',') + ',' + proj
          })
        })

        axios.all(promises).then(axios.spread((...responses) => {
          const data = _.map(responses, response => response.data)
          const featureCollection = {
            type: 'FeatureCollection',
            features: []
          }

          _.forEach(data, (featureCollectionResponse, index) => {
            const features = _.map(featureCollectionResponse.features, (feature, index) => {
              const polygon = new Polygon(feature.geometry.coordinates)
              const point = new Point(turf.center(feature).geometry.coordinates)
              const mFeature = new Feature({
                geometry: point,
                point,
                polygon,
                ...feature.properties
              })

              mFeature.setId(feature.id)
              return mFeature
            })

            featureCollection.features = [
              ...featureCollection.features,
              ...features
            ]
          })

          source.addFeatures(featureCollection.features)
        }))
      } else {
        axios.post(`${process.env.MIX_ASSET_URL}/api/ltv/wfs`, {
          typeName,
          srsname: proj,
          outputFormat: 'application/json'
          // cql_filter: _.isEmpty(byggnadsInvIds) ? null : `byggnadsid IN (${byggnadsInvIds.join(',')})`
          // bbox: extent.join(',') + ',' + proj
        })
          .then(response => response.data)
          .then(featureCollection => {
            const data = _.map(featureCollection.features, (feature, index) => {
              const polygon = new Polygon(feature.geometry.coordinates)
              const point = new Point(turf.center(feature).geometry.coordinates)
              const mFeature = new Feature({
                geometry: point,
                point,
                polygon,
                ...feature.properties
              })

              mFeature.setId(feature.id)
              return mFeature
            })

            featureCollection.features = data

            source.addFeatures(featureCollection.features)
          })
      }
    }
    // strategy: bboxStrategy
  })

  const clusterSource = new ClusterSource({
    distance: 100,
    source: source
  })

  const styleCache = {}

  const layer = new VectorLayer({
    name: type,
    className: 'kulturarvByggnaderLayer',
    zIndex: 4,
    source: clusterSource,
    minResolution: 0,
    style: function (feature, resolution) {
      // console.log()
      const mFeature = new GeoJSON().writeFeatureObject(feature.get('features')[0])
      const size = feature.get('features').length
      const detailByggnad = onByggnadsInventering && _.includes(window.location.pathname, mFeature.properties.byggnadsid)

      let style = styleCache[size]
      if (!style || size === 1) {
        style = []
        if (size > 1) {
          // Cluster
          style = [
            ...style,
            new Style({
              image: new CircleStyle({
                radius: 14,
                stroke: new Stroke({
                  color: '#fff'
                }),
                fill: new Fill({
                  color: detailByggnad ? '#d07801' : '#FE9200'
                })
              }),
              text: new Text({
                text: size.toString(),
                fill: new Fill({
                  color: '#fff'
                })
              })
            })
          ]
        } else {
          style = [
            ...style,
            new Style({
              image: new Icon({
                anchor: [60, 120],
                anchorXUnits: 'pixels',
                anchorYUnits: 'pixels',
                size: [120, 120],
                scale: 0.4,
                // src: 'https://cdn.mapmarker.io/api/v1/pin?size=120&background=%23288281&icon=fa-circle&color=%23FFFFFF&voffset=0&hoffset=1'
                src: 'https://cdn.mapmarker.io/api/v1/pin?size=120&background=%23FE9200&icon=fa-bank&color=%23FFFFFF&voffset=0&hoffset=1&'
              })
            })
          ]

          if (resolution < 2) {
            style = [
              ...style,
              new Style({
                geometry: function () {
                  return feature.get('features')[0].get('polygon')
                },
                stroke: new Stroke({
                  color: detailByggnad ? 'rgba(254,146,0,1)' : 'rgba(254,146,0,.4)',
                  width: 3
                }),
                fill: new Fill({
                  color: detailByggnad ? 'rgba(254,146,0,.65)' : 'rgba(254,146,0,.3)'
                })
              })
            ]
          }
        }
        styleCache[size] = size > 1 ? style : null
      }
      return style

      //
      // if (!convertToPoint) {
      //
      // } else {
      //   console.log('else')
      //   return onByggnadsInventering &&
      //   _.includes(window.location.pathname, mFeature.properties.byggnadsid)
      //     ? new Style({
      //       stroke: new Stroke({
      //         color: 'rgb(221,137,1)',
      //         width: 3
      //       }),
      //       fill: new Fill({
      //         color: 'rgba(221,137,1,0.7)'
      //       })
      //     })
      //     : new Style({
      //       stroke: new Stroke({
      //         color: '#ffffff',
      //         width: 3
      //       }),
      //       fill: new Fill({
      //         color: 'rgba(40,130,129,.3)'
      //       })
      //     })
      // }
    }
  })

  // layer.setSource(clusterSource)

  return layer
}

export default kulturarvByggnader
